import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-319b7793")

_pushScopeId("data-v-319b7793")
const _hoisted_1 = /*#__PURE__*/_createVNode("p", {
  class: "alert alert-warning",
  "data-cy": "PayPortal.TooEarly.Alert"
}, "This content isn't available yet.", -1)
const _hoisted_2 = { "data-cy": "PayPortal.TooEarly.Heading" }
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "You're a bit early! This content will become available on:", -1)
const _hoisted_5 = {
  class: "purchaseOpens",
  "data-cy": "PayPortal.TooEarly.PurchaseOpens"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { "data-cy": "PayPortal.TooEarly.ComeBackLater" }, "Please come back on or after that date to get your license.", -1)
_popScopeId()


import { prettyDate } from '../modules/frontend';


export default _defineComponent({
  expose: [],
  props: {
    className: { type: String, required: true },
    purchaseOpens: { type: Number, required: true }
  } as unknown as undefined,
  setup(__props: {
	className: string
	purchaseOpens: number
}) {

const props = __props




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("h1", _hoisted_2, _toDisplayString(__props.className), 1),
    _hoisted_3,
    _hoisted_4,
    _createVNode("p", _hoisted_5, _toDisplayString(_unref(prettyDate)(__props.purchaseOpens)), 1),
    _hoisted_6
  ], 64))
}
}

})